import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { TellentAppsHttpClient } from './tellent-apps.http';
import { TellentAppsActions } from './tellent-apps.store';

@Injectable({ providedIn: 'root' })
export class TellentAppsEffects {
  public effects = createEffectFactory(TellentAppsActions, this.actions$);

  public fetchApps$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TellentAppsActions.fetchCollection),
      switchMap(({ payload }) =>
        this.tellentAppHttpClient.fetchApps().pipe(
          map(({ data }) =>
            TellentAppsActions.fetchCollectionSuccess({
              payload: { data: data },
            }),
          ),
          catchError(error => of(TellentAppsActions.fetchCollectionFailed({ payload: error }))),
        ),
      ),
    ),
  );

  constructor(
    private tellentAppHttpClient: TellentAppsHttpClient,
    private actions$: Actions,
  ) {}
}
